// Generator-discovered file route for the tiered reports overview (Module P /
// P10). Tier 1 (vertical cards). Component lives in `src/ad/routes/reports.tsx`.
import { createFileRoute } from '@tanstack/react-router';
import { ReportsRouteComponent } from '@/ad/routes/reports';

export const Route = createFileRoute('/_authenticated/ad/reports/')({
  component: ReportsRouteComponent,
});
